angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/legal/legal.html',
    '<!-- Privacy -->\n' +
    '<update-title title="Privacy Policy | Legal | PEforHire.com"></update-title>\n' +
    '<update-meta\n' +
    '  name="description"\n' +
    '  content="Read P.E. For Hire’s Privacy Policy. We recognize that your privacy is important. This Policy discloses the privacy practices for P.E. For Hire, and also covers how personal and other information that we receive or collect about you is treated."\n' +
    '></update-meta>\n' +
    '<section class="content privicy">\n' +
    '  <div class="container">\n' +
    '    <div class="row">\n' +
    '      <div class="col-xs-12 col-sm-8 text-left">\n' +
    '        <h2 class="mt40">Privacy Policy</h2>\n' +
    '        <p class="privacy-date">Last updated: June 17, 2020</p>\n' +
    '\n' +
    '        <!-- Main area -->\n' +
    '        <div class="privicy-highlight">\n' +
    '          <p>\n' +
    '            On behalf of P.E. For Hire, LLC (also referred to as "us" or "we"), welcome to peforhire.com (hereinafter,\n' +
    '            the "Site"). We recognize that your privacy is important. This Policy discloses the privacy practices for\n' +
    '            the Site, and also covers how personal and other information that we receive or collect about you is\n' +
    '            treated. Please read the information below to learn the following regarding your use of the Site.\n' +
    '          </p>\n' +
    '          <p>\n' +
    '            You acknowledge that this Privacy Policy (this “Policy”) is designed to be read in connection with the\n' +
    '            Site\'s <a href="" ui-sref="terms" target="_blank">Terms and Conditions of Use</a> and Subscriber Agreement\n' +
    '            and that by accessing or using the Site, you agree to be bound by the Terms and Conditions of Use,\n' +
    '            Subscriber Agreement, and this Policy. We reserve the right to change this Privacy Policy from time to time.\n' +
    '            We will notify you about significant changes in the way we treat personal information by updating any\n' +
    '            privacy information on this page. Your continued use of the Site and or Services available through this Site\n' +
    '            after such modifications will constitute your: (a) acknowledgment of the modified Policy; and (b) your\n' +
    '            agreement to abide and be bound by that Policy.\n' +
    '          </p>\n' +
    '          <p>\n' +
    '            If you have any questions about this Policy, please feel free to contact us by email at\n' +
    '            <a href="mailto:info@peforhire.com">info@peforhire.com</a>.\n' +
    '          </p>\n' +
    '        </div>\n' +
    '\n' +
    '        <p>\n' +
    '          IMPORTANT: BY USING THE SITE AND/OR OFFERINGS AVAILABLE ON THIS SITE, YOU GIVE YOUR CONSENT THAT ALL PERSONAL\n' +
    '          DATA THAT YOU SUBMIT MAY BE PROCESSED BY US IN THE MANNER AND FOR THE PURPOSES DESCRIBED BELOW. IF YOU DO NOT\n' +
    '          AGREE TO THESE TERMS AND CONDITIONS, DO NOT USE THE SITE.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>1. Types of Information We Collect</h5>\n' +
    '        <p>\n' +
    '          We may collect several types of information about our users: (1) Personally Identifiable Information, (2)\n' +
    '          Aggregate Information, and (3) Personal Billing Information.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          <strong>Personally Identifiable Information (“PII”):</strong>\n' +
    '          This refers to information that lets us know the specifics of who you are. Examples of PII may include: your\n' +
    '          first and last name, email address, telephone number, professional license information, and business\n' +
    '          information. You may also voluntarily provide other PII, whether or not specifically requested by us, by\n' +
    '          voluntarily supplying your own details to us via email or by posting publicly viewable comments on the Site.\n' +
    '          You agree that we may collect any PII voluntarily supplied by you, whether or not we have requested it. You\n' +
    '          must not submit any PII relating to a third party which you do not have permission from such third party to\n' +
    '          provide to us. We do not knowingly collect any information relating to third parties which you do not have\n' +
    '          permission to provide. When you engage in certain activities on our Site, such as registering or sending us a\n' +
    '          message or written content via email, we will ask you to provide certain PII\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          <strong>Aggregate Information:</strong>\n' +
    '          This refers to information that does not by itself identify a specific individual. We gather certain\n' +
    '          information about you based upon where you visit on our Site and what other Sites may have directed you to us.\n' +
    '          This information, which is collected in a variety of different ways, is compiled and analyzed on both a\n' +
    '          personal and an aggregated basis. This information may include the WebSite\'s Uniform Resource Locator ("URL")\n' +
    '          that points to the site you just came from, which URL you go to after visiting our Site, what browser you are\n' +
    '          using, and your Internet Protocol ("IP") address.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          <strong>Personal Billing Information:</strong>\n' +
    '          This refers to information, such as your billing address and credit card number, when you purchase our\n' +
    '          service. We use secure servers to gather and process your billing information, which will be utilized and\n' +
    '          stored by third party merchant services. Your billing information is not shared with any other organizations.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          <em>Note on European Citizens or Residents</em>: we do not attempt to offer or market our Site or Services to\n' +
    '          citizens or residents of member states of the European Union or the European Economic Area. As stated in our\n' +
    '          <a href="" ui-sref="terms" target="_blank">Terms and Conditions</a>, you are prohibited from using our Site or\n' +
    '          Services if you are a citizen or resident of the European Union or European Economic Area. Do not submit any\n' +
    '          PII if you are a citizen or resident of the European Union or European Economic Area, as such is a violation\n' +
    '          of our Terms and Conditions.\n' +
    '        </p>\n' +
    '        <br />\n' +
    '        <h5>2. How We Collect and Use Information</h5>\n' +
    '        <p>\n' +
    '          We do not collect any PII about you unless you voluntarily provide it to us or affiliates, service providers,\n' +
    '          partners, and other third parties ("Service Partners") that assist us in providing the Site and the Services\n' +
    '          to you. You may be required to provide certain PII to us when you elect to use certain services available on\n' +
    '          the Site.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          We will primarily use your PII to provide information and service offerings to you. We will also use certain\n' +
    '          forms of PII to enhance the operation of our Site, improve our internal marketing efforts, statistically\n' +
    '          analyze Site use, improve our information offerings, and customize the Site\'s content, layout and services. We\n' +
    '          may use PII to deliver information or service offerings to you, and to contact you if you request that we do\n' +
    '          so. Finally, we may use your PII to enforce our agreements with you, including our Site\'s Terms and Conditions\n' +
    '          of Use and this Privacy Policy.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          We may also collect certain Aggregate Information. For example, we may use your IP address to diagnose\n' +
    '          problems with our servers, software, to administer our Site, and to gather demographic information.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track (“DNT”)\n' +
    '          feature or setting you can activate to signal your privacy preference not to have data about your online\n' +
    '          browsing activities monitored and collected. No uniform technology standard for recognizing and implementing\n' +
    '          DNT signals has been finalized. We attempt to honor DNT browser signals or any other mechanism that\n' +
    '          automatically communicates your choice not to be tracked online; however, please understand that this is not\n' +
    '          always possible. Further, we will follow any standard for online tracking if one emerges that we must follow\n' +
    '          in the future.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          Nonetheless, as stated above, the information we collect from your browser whether or not you enable DNT\n' +
    '          signals is minimal and adheres to the other provisions of this Policy.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>3. Cookies</h5>\n' +
    '        <p>\n' +
    '          Depending on how you use our Site, we may store cookies on your computer in order to collect certain aggregate\n' +
    '          data about our users and to customize certain aspects of your specific user experience. A cookie is a small\n' +
    '          data text file which is stored on your computer that uniquely identifies your browser. Cookies may also\n' +
    '          include more personalized information, such as your IP address, browser type, the server your computer is\n' +
    '          logged onto, the area code and zip code associated with your server, and your first name to welcome you back\n' +
    '          to our Site. We may use cookies to perform tasks such as: monitoring aggregate Site usage metrics, storing and\n' +
    '          remembering your passwords (if you allow us to do so), storing account and advertising preferences that you\n' +
    '          have set, and personalizing the Services we make available to you. However, we do not use cookies to track\n' +
    '          your browsing behaviors.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          Most browsers are initially set up to accept cookies, but you can reset your browser to refuse all cookies or\n' +
    '          to indicate when a cookie is being sent. However, some aspects of the Site may not function properly if you\n' +
    '          elect to disable cookies.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>4. Release of Information</h5>\n' +
    '        <p>\n' +
    '          We do provide some of our service offerings through contractual arrangements made with affiliates, service\n' +
    '          providers, partners, and other third parties ("Service Partners"). We and our Service Partners may need to use\n' +
    '          some PII in order to perform tasks between our respective sites, or to deliver services to you. For example,\n' +
    '          we may use Service Partners to assist us in billing, shipping, ensuring payments are distributed to parties of\n' +
    '          an agreed-upon transaction during normal offering of the Services (“Escrow Services”), and age verification;\n' +
    '          delivering electronic newsletters and communications to you; to collect PII voluntarily submitted by you when\n' +
    '          leaving comments on the Site; and to analyze Aggregate Information.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          We will choose Service Partners who adopt and promote strong privacy policies. However, the use of your PII by\n' +
    '          our Service Partners is governed by the respective privacy policies of those providers and is not subject to\n' +
    '          our control.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          Except as otherwise discussed in this Privacy Policy, this document only addresses the use and disclosure of\n' +
    '          information we collect from you. Any other sites accessible through our Site, including those of our Service\n' +
    '          Partners, have their own privacy policies and data collection, use and disclosure practices. Please consult\n' +
    '          each site\'s privacy policy. We are not responsible for the policies or practices of third parties.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          Other than our Service Partners, we do not allow outside parties to collect PII or Aggregate Information about\n' +
    '          you or your online activities when you use our Site. However, by utilizing our service offerings, you have\n' +
    '          agreed to make certain PII available to Hiring Parties and/or P.E.s in order to facilitate the connection for\n' +
    '          listed projects and proposals for those projects. PII about Hiring Parties and/or P.E.s is distributed to\n' +
    '          counter-parties when a proposal is agreed to by both parties. We cannot directly control Hiring Parties and/or\n' +
    '          P.E.s may store, process, or use others’ PII; however,\n' +
    '          <strong\n' +
    '            ><u>\n' +
    '              by using the Site or our Services, you agree to handling, storing, and sharing the PII or other\n' +
    '              information of any party you are introduced to through the Services in line with this Policy.\n' +
    '            </u></strong\n' +
    '          >\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          Occasionally we may be required by law enforcement or judicial authorities to provide PII to the appropriate\n' +
    '          governmental authorities. In such cases, we will disclose PII upon receipt of a court order, subpoena, or to\n' +
    '          cooperate with a law enforcement investigation. We fully cooperate with law enforcement agencies in\n' +
    '          identifying those who use our services for illegal activities. We reserve the right to report to law\n' +
    '          enforcement agencies any activities that we in good faith believe to be unlawful.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>5. Updating and Correcting Information</h5>\n' +
    '        <p>\n' +
    '          We believe you should have the ability to access and edit the PII that you have provided to us. You may change\n' +
    '          any of your PII in your account online at any time. You may request that your account be deleted sending an\n' +
    '          email to <a href="mailto:info@peforhire.com">info@peforhire.com</a>. Please include your name and email\n' +
    '          address when you contact us.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          We encourage you to promptly update your PII if it changes. You may ask to have the information on your\n' +
    '          account deleted or removed; however, some information, such as logs of technical support calls or other\n' +
    '          information may not be deleted. In addition, it may be impossible to completely delete your information\n' +
    '          without some residual information because of backups.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>6. User Choices on Collection and Use of Information</h5>\n' +
    '        <p>\n' +
    '          We may, from time to time, send you emails and/or newsletters regarding information or services that we feel\n' +
    '          may interest you. Only P.E. For Hire, LLC (or agents working on behalf of P.E. For Hire, LLC and under\n' +
    '          confidentiality agreements) will send you these notifications. If you do not want to receive correspondence\n' +
    '          from us, you can "opt-out" by clicking on the "Unsubscribe" link at the bottom of each correspondence.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          You also have choices with respect to cookies, as described above. By modifying your browser preferences, you\n' +
    '          have the choice to accept all cookies, to be notified when a cookie is set, or to reject all cookies. If you\n' +
    '          choose to reject all cookies, some parts of our Site may not work properly in your case.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>7. Security of Your PII</h5>\n' +
    '        <p>\n' +
    '          At our Site you can be assured that your PII is secure as we strive to take appropriate security measures to\n' +
    '          protect against unauthorized access to or unauthorized alteration, disclosure, or destruction of your PII. For\n' +
    '          example:\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          — We work hard to ensure that the data we collect is reliable, accurate, complete and current. We use PII only\n' +
    '          for the purposes for which it was collected or to comply with any applicable legal or ethical reporting or\n' +
    '          document retention requirements.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          — We limit access to PII only to specific employees, Service Partners, contractors, and agents who have a\n' +
    '          reasonable need to come into contact with your information.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          — We attempt to limit the PII provided to us by Service Providers or other third parties to only that required\n' +
    '          for the successful offering of our Services. For example, we do not collect your unredacted or\n' +
    '          non-pseudonymized Personal Billing Information from Escrow Services, though we may collect a record of the\n' +
    '          transaction itself or other related information as is required for our normal business operations.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          — We attempt to reduce the amount of sensitive data on our systems by routinely deleting PII or anonymizing\n' +
    '          data that we determine is unlikely to be relevant to the ongoing provision of our Services. You may be\n' +
    '          required to re-submit some information if you begin using our Site or Services again after one year of\n' +
    '          inactivity as that information might no longer be stored in our systems.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          — Additionally, we also employ a number of physical, electronic, and procedural safeguards to protect PII. Our\n' +
    '          secure servers and our data centers are protected by encryption, and our servers reside behind firewalls and\n' +
    '          password protection.\n' +
    '        </p>\n' +
    '        <p>\n' +
    '          Unfortunately, no data transmission over the Internet or any wireless network can be guaranteed to be 100%\n' +
    '          secure. As a result, while we strive to protect your PII, you acknowledge that: (a) there are security and\n' +
    '          privacy limitations inherent to the Internet which are beyond our control; and (b) the security, integrity and\n' +
    '          privacy of any and all information and data exchanged between you and us through the Site cannot be\n' +
    '          guaranteed.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>8. Children</h5>\n' +
    '        <p>\n' +
    '          You must be at least 18 years old to have our permission to use our Site. With respect to children, P.E. For\n' +
    '          Hire, LLC does not knowingly collect any PII about, for, or on behalf of children. We do not share that\n' +
    '          information in any other way or with any other parties.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>9. Miscellaneous</h5>\n' +
    '        <p>\n' +
    '          You should also be aware that when PII is voluntarily disclosed (i.e.; your name, email address, etc.) by you\n' +
    '          in the comments you post on the Site or in other public areas on the Site, that information, along with any\n' +
    '          information disclosed in your communication, can be collected and used by third parties and may result in\n' +
    '          unsolicited messages (including unwanted spam messages) from third parties. Such activities are beyond our\n' +
    '          control and this Policy does not apply to such information. Please consult our\n' +
    '          <a href="" ui-sref="terms" target="_blank">Terms and Conditions</a> of Use for policies regarding\n' +
    '          user-provided information.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>10. California Disclosures.</h5>\n' +
    '        <p>\n' +
    '          Upon your request, California Civil Code Section 1798.83, known as the "Shine the Light" law, requires us to\n' +
    '          provide to you (a) a list of your personal information, if any, which we have disclosed to third parties for\n' +
    '          direct marketing purposes in the preceding calendar year, and (b) the names and addresses of those third\n' +
    '          parties. You may make such a request once per calendar year, and we will provide the information to you free\n' +
    '          of charge. Please send any requests made pursuant to this section to us by email a\n' +
    '          <a href="mailto:info@peforhire.com">info@peforhire.com</a>. However, as defined under Section 1798.83, we do\n' +
    '          not currently share any personal information with third parties for their direct marketing purposes.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>11. No Rights of Third Parties.</h5>\n' +
    '        <p>\n' +
    '          This Privacy Policy does not create rights enforceable by third parties or require disclosure of any personal\n' +
    '          information relating to users.\n' +
    '        </p>\n' +
    '\n' +
    '        <br />\n' +
    '        <h5>12. Contact Us.</h5>\n' +
    '        <p>\n' +
    '          If you have any questions, concerns, or inquiries about our Privacy Policy, our use of your PII, or our\n' +
    '          privacy practices, please contact us by email at <a href="mailto:info@peforhire.com">info@peforhire.com</a>.\n' +
    '        </p>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- Right side -->\n' +
    '      <div class="col-sm-4 mt100 hidden-xs" ng-show="!standAlone">\n' +
    '        <h3>More Questions?</h3>\n' +
    '        <p>Submit a contact form</p>\n' +
    '        <a class="btn btn-primary" href="" ui-sref="about({\'#\':\'contact\'})">Open Contact Form</a>\n' +
    '        <p class="mt40">Send an email</p>\n' +
    '        <h5 class="text-muted">\n' +
    '          <a href="mailto:info@peforhire.com">info@peforhire.com</a>\n' +
    '        </h5>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
}]);
